import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function EmotionalHook() {
  return <SectionWrapper className="bg-white py-20" data-id="element-114">
      <div className="max-w-3xl mx-auto" data-id="element-115">
        <div className="prose prose-lg md:prose-xl prose-p:text-ink-mid prose-p:font-sans prose-p:leading-relaxed max-w-none" data-id="element-116">
          <p className="font-medium text-ink" data-id="element-117">
            Si eso te suena familiar, quiero que sepas algo antes de seguir:
          </p>

          <p className="text-3xl font-sans text-coral font-bold my-8" data-id="element-118">
            No estás fallando como padre o madre.
          </p>

          <p data-id="element-119">
            Estás usando herramientas que no fueron diseñadas para este momento.
          </p>

          <p data-id="element-120">
            Nadie te enseñó qué hacer exactamente cuando tu hijo pierde el
            control.
          </p>

          {/* CONTRAST TABLE (MEJORA 4) */}
          <div className="grid md:grid-cols-2 gap-6 my-12 not-prose" data-id="element-121">
            <div className="bg-cream-dark p-6 rounded-xl" data-id="element-122">
              <h3 className="font-sans font-bold text-ink mb-4 text-lg" data-id="element-123">
                Lo que SÍ te enseñaron
              </h3>
              <ul className="space-y-3" data-id="element-124">
                <li className="flex items-center gap-2 font-sans text-ink-mid" data-id="element-125">
                  <span className="text-green-500" data-id="element-126">✔️</span> A corregir
                </li>
                <li className="flex items-center gap-2 font-sans text-ink-mid" data-id="element-127">
                  <span className="text-green-500" data-id="element-128">✔️</span> A exigir
                </li>
                <li className="flex items-center gap-2 font-sans text-ink-mid" data-id="element-129">
                  <span className="text-green-500" data-id="element-130">✔️</span> A poner límites
                </li>
              </ul>
            </div>
            <div className="bg-white border-2 border-coral p-6 rounded-xl" data-id="element-131">
              <h3 className="font-sans font-bold text-ink mb-4 text-lg" data-id="element-132">
                Lo que NADIE te enseñó
              </h3>
              <p className="flex items-start gap-2 font-sans text-ink-mid font-medium" data-id="element-133">
                <span className="text-red-500 shrink-0 mt-1" data-id="element-134">❌</span>
                Qué hacer en los próximos 60 segundos cuando ya explotó.
              </p>
            </div>
          </div>

          <p data-id="element-135">Así que improvisas.</p>

          <p data-id="element-136">Gritas porque no sabes qué más hacer.</p>

          <p data-id="element-137">Amenazas porque necesitas que pare ya.</p>

          <p data-id="element-138">
            Explains y razonas con alguien que en ese momento no puede
            escucharte.
          </p>

          <p data-id="element-139">
            Y cuando pasa, sientes esa mezcla conocida de agotamiento,
            frustración y culpa.
          </p>

          <div className="bg-cream p-8 rounded-xl mt-12 text-center border border-hairline" data-id="element-140">
            <p className="font-sans text-2xl font-bold text-ink mb-2" data-id="element-141">
              Eso no es un problema de voluntad.
            </p>
            <p className="font-sans text-2xl font-bold text-coral" data-id="element-142">
              Es un problema de método.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}